export default __webpack_public_path__ + "static/media/workspacehighlight.c0da3f7f.svg";